import Component from '../abstracts/Component';
import FixBody from '../utils/FixBody';
import {emit} from "../utils/EventsBus";
import {CustomEvents} from "../utils/CustomEvents";

export default class CategoryFilterComponent extends Component {
  get SELECTORS() {
    return {
      showMore: '[data-show-more]',
      showLess: '[data-show-less]',
      secondaryList: '[data-secondary-list]',
      submenuPanel: '[data-submenu-panel]',
      submenuPanelClose: '[data-trigger-close]',
      benefitBar: '[data-benefit-bar]',
      salesPager: '[data-sales-pager]',
    };
  }
  constructor(htmlEl) {
    super(htmlEl);
    this.showMore = this.$component.querySelector(this.SELECTORS.showMore);
    this.showLess = this.$component.querySelector(this.SELECTORS.showLess);
    this.secondaryList = this.$component.querySelector(
      this.SELECTORS.secondaryList
    );
    this.submenuPanel = this.$component.querySelector(
      this.SELECTORS.submenuPanel
    );
    this.submenuPanelClose = this.$component.querySelector(
      this.SELECTORS.submenuPanelClose
    );
  }

  render() {
    this.bindEvents();
    this.updatePager();
  }

  updatePager() {
    // global
    let ctx = this;
    // listen to update filter event
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      // update pager html
      let source = payload.response.querySelector(ctx.SELECTORS.salesPager);
      let target = document.querySelector(ctx.SELECTORS.salesPager);
      if(typeof source !== 'undefined' && source != null && typeof target !== 'undefined' && target != null ) {
        // update the html pager
        target.innerHTML = source.innerHTML;
        // showit
        target.classList.remove('hidden');
      } else if (source == null && typeof target !== 'undefined' && target != null) {
        // let's hide the paginator if when filtered i have no pagination
        target.classList.add('hidden');
      }
    });

  }

  bindEvents() {
    let scrollY = 0;
    let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
    if (this.showMore != null) {
      this.showMore.addEventListener('click', () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.showMore.style.display = 'none';
          this.secondaryList.style.display = 'block';
        } else {
          this.submenuPanel.classList.add('open');
          scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
          FixBody.block(barHeight);
        }
      });
    }
    if (this.showLess != null) {
      this.showLess.addEventListener('click', () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.showMore.style.display = 'block';
          this.secondaryList.style.display = 'none';
        }
      });
    }
    if (this.submenuPanelClose != null) {
      this.submenuPanelClose.addEventListener('click', () => {
        this.submenuPanel.classList.remove('open');
        FixBody.unblock(scrollY);
      });
    }
  }
}
